import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'activity';
const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const GET_USER_ACTIVITY = createApiNamespacedConstants('get_user_activity');
export const GET_ORGANIZATION_ACTIVITY = createApiNamespacedConstants('get_organization_activity');
export const GET_TEAMS_ACTIVITY = createApiNamespacedConstants('get_teams_activity');
export const GET_GROUPS_ACTIVITY = createApiNamespacedConstants('get_groups_activity');
export const DOWNLOAD_USER_ACTIVITY_CSV = createApiNamespacedConstants('download_user_activity_csv');
export const DOWNLOAD_ORGANIZATION_ACTIVITY_CSV = createApiNamespacedConstants('download_organization_activity_csv');
export const DOWNLOAD_TEAM_ACTIVITY_CSV = createApiNamespacedConstants('download_team_activity_csv');
export const DOWNLOAD_GROUP_ACTIVITY_CSV = createApiNamespacedConstants('download_group_activity_csv');
